import { Icon } from '@getsynapse/design-system';
import classnames from 'classnames';
import intl from 'react-intl-universal';
import useLogout from 'Hooks/useLogout';

import logout from 'assets/icons/logout.svg';

const LogoutButton = ({ isExpanded }: { isExpanded: boolean }) => {
  const handleLogout = useLogout();

  return (
    <button
      onClick={handleLogout}
      className={classnames(
        'flex',
        'h-10',
        'items-center',
        'text-center',
        'text-neutral-white',
        'hover:bg-primary-darker',
        'hover:bg-opacity-50',
        'focus:bg-primary-darker',
        'focus:bg-opacity-50',
        'rounded',
        'text-label',
        'border-l-4 border-transparent',
        'px-2',
        'focus:outline-none'
      )}
      data-cy='logout-button'
    >
      <Icon
        src={logout}
        className={classnames('h-5', 'w-5', 'text-neutral-white')}
        aria-label={intl.get('SIDEBAR.LOGOUT')}
      />
      {isExpanded && <span className='ml-1'>{intl.get('SIDEBAR.LOGOUT')}</span>}
    </button>
  );
};

export default LogoutButton;
